import useMarkdown from '../hooks/useMarkdown';

type Props = { children: string };

const InlineMarkdown: React.FC<Props> = ({ children }) => {
  const markdown = useMarkdown();

  return (
    <span
      onClick={(event) => {
        event.stopPropagation();
      }}
      dangerouslySetInnerHTML={{
        __html: markdown.renderInline(children),
      }}
    />
  );
};

export default InlineMarkdown;
